import EstimateChip from "@/components/FitnessProfile/EstimateChip";
import { Trans } from "@lingui/macro";
import { Box, Stack, Typography } from "@mui/material";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";

type Props = {
  icon?: JSX.Element;
  name?: string;
  handleEstimateClick?: () => void;
  profileType: WahooWorkoutTypeFamily;
};
function ResultsHeader({ icon, name, handleEstimateClick, profileType }: Props) {
  return (
    <Stack direction="column" alignItems="center" px={2} width="100%" gap={1.2} pt={4}>
      <Stack direction="column" alignItems="center" spacing={1.5}>
        <Typography variant="ui-xl-medium">
          <Trans>Wahoo!</Trans>
        </Typography>
        <Typography variant="ui-md-medium" textAlign="center">
          {profileType === WahooWorkoutTypeFamily.Cycling ? (
            <Trans>We estimated your Cycling Athlete Profile as:</Trans>
          ) : (
            <Trans>We estimated your Running Athlete Profile as:</Trans>
          )}
        </Typography>
      </Stack>
      <Stack direction="column" alignItems="center" spacing={1.5}>
        <Box width={64} height={64} ml={1.5}>
          {icon}
        </Box>
        <Typography variant="ui-4xl-bold">{name}</Typography>
        <EstimateChip handleClick={handleEstimateClick} />
      </Stack>
    </Stack>
  );
}

export default ResultsHeader;
